import React from 'react';
import * as S from './route-card.styles';
import RupeeIcon from '../../../../icons/Rupee';

const SeoCard = props => {
  const {
    airlineCode,
    airlineName,
    sourceIata,
    sourceName,
    destIata,
    destName,
    url,
    price,
    isDweb = false
  } = props;

  if (!price) {
    return null;
  }

  const cardClickHandler = (isDweb, url) => {
    if (!isDweb) {
      window.location.href = `https://${url}`;
    }
  };

  return (
    <S.SeoCard
      className="flexCol width100"
      onClick={() => {
        cardClickHandler(isDweb, url);
      }}
    >
      <S.CardWrap className="width100 dF padB10">
        <div className="dF width100 padT10 padB10 alignItemsCenter">
          <div className="dF alignItemsCenter flex1">
            <S.CarrierLogo
              src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${airlineCode}.png`}
              alt="Airline Image"
            />
            {isDweb ? <span className="font14 padL5">{airlineName}</span> : null}
          </div>
          <div className="flexCol flex1">
            <S.Time className="txtUpper fb padB5">{sourceIata} </S.Time>
            <span className="font11 grey">{sourceName}</span>
          </div>
          <div className="padT5 flexCol flex1">
            <S.DurBordr className="width50"></S.DurBordr>
          </div>
          <div className="flexCol flex1">
            <S.Time className="txtUpper fb padB5">{destIata}</S.Time>
            <span className="font11 grey">{destName}</span>
          </div>
          <div className="dF flex1 justifyCenter">
            <S.Price className="dF fb alignItemsCenter">
              <RupeeIcon fill="#141823" />
              {price}
            </S.Price>
          </div>
          {isDweb ? (
            <div className="dF flex1 justifyEnd">
              <S.BookButton route className="width100">
                <a href={`https://${url}`} className="seoLink white">
                  View More
                </a>
              </S.BookButton>
            </div>
          ) : null}
        </div>
      </S.CardWrap>
    </S.SeoCard>
  );
};

export default SeoCard;
